/**
 * Build-time wiring of lazily loaded content: one chunk per level JSON, one per pack index,
 * and the optional @mp/audio module. Globs resolve to empty maps when files do not exist.
 */
import type { LevelV1 } from '@mp/core';
import type { AudioEngine } from '../services/audio.js';
import type { LevelSources, Pack } from '../services/levels.js';

const packFiles = import.meta.glob<Pack>('../../../../content/levels/*/pack.json', { import: 'default' });
const levelFiles = import.meta.glob<LevelV1>(['../../../../content/levels/*/*.json', '!**/pack.json'], { import: 'default' });
const audioFiles = import.meta.glob<{ createAudio?: () => AudioEngine }>('../../../../packages/audio/src/index.ts');

export function levelSources(devFallback: boolean): LevelSources {
  const packs: LevelSources['packs'] = {};
  for (const [path, load] of Object.entries(packFiles)) {
    const city = path.split('/').slice(-2)[0]!;
    packs[city] = load;
  }
  const levels: LevelSources['levels'] = {};
  for (const [path, load] of Object.entries(levelFiles)) {
    const id = path.split('/').pop()!.replace(/\.json$/, '');
    levels[id] = load;
  }
  if (!devFallback) return { packs, levels };
  return {
    packs,
    levels,
    dev: {
      count: 30,
      generate: (city, n) => import('../services/devLevels.js').then((m) => m.generateDevLevel(city, n)),
    },
  };
}

export function audioLoader(): (() => Promise<{ createAudio?: () => AudioEngine }>) | null {
  return Object.values(audioFiles)[0] ?? null;
}
